import { render } from "./CurrentlyUnavailable.vue?vue&type=template&id=6d96c176&scoped=true"
const script = {}

import "./CurrentlyUnavailable.vue?vue&type=style&index=0&id=6d96c176&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d96c176"]])

export default __exports__